import { PageLayout } from '../../components/PageLayout.jsx'
import { CredBar } from '../../components/CredBar.jsx'
import { CtaStrip } from '../../components/CtaStrip.jsx'
import { BRAND_TAGLINE } from '../../constants/brand.js'
import { usePageMeta } from '../../hooks/usePageMeta.js'
import { Hero } from './components/Hero.jsx'
import { FoundingMembersBanner } from './components/FoundingMembersBanner.jsx'
import { FeaturedService } from './components/FeaturedService.jsx'
import { HowItWorks } from './components/HowItWorks.jsx'
import { WhatWeTreat } from './components/WhatWeTreat.jsx'
import { ClinicalTrust } from './components/ClinicalTrust.jsx'
import { Testimonials } from './components/Testimonials.jsx'
import { FinalCTA } from './components/FinalCTA.jsx'

export function HomePage() {
  usePageMeta(BRAND_TAGLINE, BRAND_TAGLINE)

  return (
    <PageLayout>
      <FoundingMembersBanner />
      <Hero />
      <CredBar />
      <FeaturedService />
      <HowItWorks />
      <WhatWeTreat />
      <ClinicalTrust />
      <Testimonials />
      <FinalCTA />
      <CtaStrip />
    </PageLayout>
  )
}
